import * as React from "react";
import { useEffect } from "react";
import { Route, HashRouter as Router, Routes } from "react-router-dom";
import Api from "./api";
import { CreditsProvider } from "./credits";
import { User } from "./models";
import TextPage from "./pages/TextPage";
import TextsPage from "./pages/TextsPage";

const App: React.FC = () => {
  const [me, setMe] = React.useState<User | null>(null);

  async function loadMe() {
    const res = await Api.users.me();
    if ("error" in res) {
      // unauthenticated
      setMe(null);
      return;
    }
    setMe(res);
  }

  useEffect(() => {
    loadMe();
  }, []);

  return (
    <Router>
      <CreditsProvider>
        <div className="app">
          <Routes>
            <Route path="/" element={<TextsPage user={me} />} />
            <Route path="/texts" element={<TextsPage user={me} />} />
            <Route path="/texts/:uid" element={<TextPage base="texts" />} />
            {/*
            <Route path="/povs" element={<PovsPage />} />
            <Route path="/povs/:uid" element={<TextPage base="povs" />} />*/}
            <Route path="/train" element={<div>Coming soon...</div>} />
          </Routes>
        </div>
      </CreditsProvider>
    </Router>
  );
};

export default App;
